import { VueReCaptcha } from 'vue-recaptcha-v3';
export default (function (_ref) {
  var Vue = _ref.Vue;
  Vue.use(VueReCaptcha, {
    siteKey: process.env.RECAPTCHA_KEY,
    loaderOptions: {
      useEnterprise: true,
      autoHideBadge: true
    }
  });
});